import { Component, OnInit } from '@angular/core';
import { UserDetails } from '../../model/UserDetails';
import { ApiService } from '../../services/api.service';
import { LaunchDarklyUtil } from '../../shared/launch-darkly-util';
import { Router } from '@angular/router';
import { UserRolesService } from 'src/app/services/user-roles.service';

@Component({
  standalone: false,
  selector: 'app-main-body-view',
  templateUrl: './main-body-view.component.html',
  styleUrls: ['./main-body-view.component.css']
})
export class MainBodyViewComponent implements OnInit {

  userDetails: UserDetails;
  showDueDiligenceDashboard = false;
  showInsurance = false;

  unauthorizedUser = false;

  // client: LDClient.LDClient;
  systemDownFlagValue = {};
  showSystemDown = false;

  menu: any[] = [];

  constructor(
    private router: Router,
    private apiService: ApiService,
    private userRolesService: UserRolesService,
    private launchDarkly: LaunchDarklyUtil) { }

  ngOnInit(): void {
    this.userDetails = this.apiService.getUserDetails();

    this.apiService.userDetailsSub.subscribe((userDetails) => {
      this.userDetails = userDetails;
      this.initMenu()
    })
  }

  initMenu() {
    if (this.showSystemDown == true) {
      // this.menu = [];
      return;
    }

    this.initLaunchDarkly();

    if (this.userDetails) {
      this.showDueDiligenceDashboard = this.userRolesService.isShowDueDiligenceDashboard(this.userDetails)
      this.showInsurance = this.userRolesService.isShowInsuranceDashboard(this.userDetails);


      this.menu = [];
      this.addDueDiligenceMenu();
      this.addInsuranceMenu();

      if (this.menu.length == 0) {
        this.unauthorizedUser = true;
        this.router.navigate(['/un-authorized'], { skipLocationChange: true });
      }
    }
  }

  private addDueDiligenceMenu() {
    if (this.showDueDiligenceDashboard) {
      this.menu.push(
        {
          title: 'Due Diligence Reports',
          url: 'dd_dashboard',
          list: [],
          exactMatch: true,
          command: () => this.router.navigate(['/dd_dashboard'], { skipLocationChange: true }),
        });
    }
  }

  private addInsuranceMenu() {
    if (this.showInsurance) {
      this.menu.push(
        {
          title: 'Insurance',
          url: 'insurance',
          list: [],
          exactMatch: true,
          command: () => this.router.navigate(['/insurance'], { skipLocationChange: true }),
        });
    }
  }

  initLaunchDarkly() {
    this.launchDarkly.getLaunchDarklyShutDown(this, this.launchDarklyCallback)
  }

  launchDarklyCallback(systemDownFlagValue: boolean, caller) {
    caller.systemDownFlagValue = systemDownFlagValue;
    console.log('LaunchDarkly flag systemDownFlagValue = ', caller.systemDownFlagValue);
    if (Object.keys(caller.systemDownFlagValue).length > 0) {
      // caller.apiService.systemDownFlagValue = caller.systemDownFlagValue;
      caller.menu = [];
      caller.showSystemDown = true;
      caller.showDueDiligenceDashboard = false;
      caller.unauthorizedUser = false;

      caller.apiService.shutDownApp = true;
      caller.router.navigate([''], { skipLocationChange: true });
    }
  }
}
